/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Gallery_Empty_CtaInputs */



/**
* | output |
* | --- |
* | "Create the first promo" |
*
* @param {Promo_Gallery_Empty_CtaInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_gallery_empty_cta = /** @type {((inputs?: Promo_Gallery_Empty_CtaInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Gallery_Empty_CtaInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer la première promo")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear la primera promo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Criar a primeira promo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea la prima promo")
	return /** @type {LocalizedString} */ ("Create the first promo")
});